import azureconfigValues from "../config/azureConfigValues";

const checkUrl = (env: string[]) =>
  env.filter((eu) => window.location.origin.indexOf(eu) > -1).length > 0;

export const isLocalhost = () => checkUrl(azureconfigValues.local.urls);

export const isSandbox = () => checkUrl(azureconfigValues.sandbox.urls);

export const isDev = () => checkUrl(azureconfigValues.dev.urls);

export const isTest = () => checkUrl(azureconfigValues.test.urls);
